import React from "react";
import {
  Tab as BootstrapTab,
  Tabs as BootstrapTabs,
  Dropdown as BootstrapDropdown,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import "style/requests.css";
import { userStore } from "entities/User/store/userStore";
import CardRequestsAccordion from "modules/CorporateCardRequests/components/CardRequests.Accordion/CardRequests.Accordion";
import { useNavigate, useParams } from "react-router-dom";

const CardRequestsTabs = ({
  data,
  dataKey,
  tabs,
  loading,
  error,
  errorKey,
  cardFormat
}) => {
  const navigate = useNavigate();
  const { key } = useParams();
  const isMobile = userStore((state) => state.isMobile);

  return !isMobile ? (
    <BootstrapTabs
      className="tabs_requests pt-3 mb-4"
      activeKey={key}
      onSelect={(key) => navigate(`/`+(cardFormat==='corporate'?'corporate':'cards')+`-requests/${key}`)}
    >
      {tabs.map((tab, index) => (
        <BootstrapTab
          id={`card-${key}-requests-tab-test-id-${index}`}
          key={tab.key}
          eventKey={tab.key}
          title={
            <>
              <FontAwesomeIcon icon={faUser} className="mx-3" /> {tab.label}
            </>
          }
          className="tab_requests d-flex justify-content-center"
          disabled={tab.key !== key && loading}
        >
          {tab.key === key && (
            <CardRequestsAccordion
              data={data}
              dataKey={dataKey}
              tabKey={key}
              loading={loading}
              error={error}
              errorKey={errorKey}
              items={tab.accordions}
              cardFormat={cardFormat}
            />
          )}
        </BootstrapTab>
      ))}
    </BootstrapTabs>
  ) : (
    <>
      <BootstrapDropdown className="my-3">
        <BootstrapDropdown.Toggle variant="success" id="dropdown-basic">
          Request Type
        </BootstrapDropdown.Toggle>
        <BootstrapDropdown.Menu>
          {tabs.map((tab) => (
            <BootstrapDropdown.Item
              key={tab.key}
              as="button"
              onClick={(key) => navigate(`/`+(cardFormat==='corporate'?'corporate':'cards')+`-requests/${tab.key}`)}
            >
              {tab.label}
            </BootstrapDropdown.Item>
          ))}
        </BootstrapDropdown.Menu>
      </BootstrapDropdown>
      <CardRequestsAccordion
        data={data}
        dataKey={dataKey}
        tabKey={key}
        loading={loading}
        error={error}
        errorKey={errorKey}
        items={tabs.find((tab) => tab.key === key)?.accordions}
        cardFormat={cardFormat}
      />
    </>
  );
};

export default CardRequestsTabs;
